import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { GameMode } from '@dc-core/dc-backend/dc-enums';

import { GamesTrialService } from '../services/games-trial.service';

export const gamesTrialGuard: CanActivateFn = (route) => {
    const gamesTrialService: GamesTrialService = inject(GamesTrialService);
    const gameMode: GameMode = route.data.gameMode;

    return gamesTrialService.hasValidTrial(gameMode);
};
